var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldPlus = function SvgShieldPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shield-plus_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shield-plus_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.546 5.758C19.93 8.915 14.652 11.5 10.25 11.5a.75.75 0 0 0-.75.75v14c0 4.67 1.62 8.107 4.187 10.737 2.601 2.664 6.231 4.553 10.311 5.961l.028.01a.75.75 0 0 0 .499.01c4.068-1.42 7.692-3.313 10.29-5.978C37.38 34.359 39 30.92 39 26.25v-14a.75.75 0 0 0-.75-.75c-4.401 0-9.658-2.565-13.296-5.743a1.09 1.09 0 0 0-1.408 0ZM21.918 3.86a3.59 3.59 0 0 1 4.664 0l.01.009C29.956 6.809 34.655 9 38.25 9a3.25 3.25 0 0 1 3.25 3.25v14c0 5.331-1.88 9.393-4.895 12.486-2.98 3.058-7.014 5.114-11.264 6.595l-.01.004a3.25 3.25 0 0 1-2.162-.027c-4.255-1.47-8.29-3.52-11.27-6.574C8.88 35.644 7 31.581 7 26.251v-14A3.25 3.25 0 0 1 10.25 9c3.595 0 8.314-2.211 11.658-5.131l.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 24.25c0-.69.56-1.25 1.25-1.25h12a1.25 1.25 0 1 1 0 2.5h-12c-.69 0-1.25-.559-1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 17c.69 0 1.25.56 1.25 1.25v12a1.25 1.25 0 1 1-2.5 0v-12c0-.69.56-1.25 1.25-1.25Z"
  }))));
};
export default SvgShieldPlus;